package com.crowpay.extensions

import com.crowpay.Contractor
import com.crowpay.SharedUtils

// this is the old validation for contractors, it shouldn't be used anymore
fun Contractor.basicInfoComplete(): Boolean =
    name.isNotBlank() &&
            email.matches(SharedUtils.emailPattern) &&
            phoneNumber.matches(SharedUtils.phonePattern) &&
            address.isNotBlank() &&

            contactFirstName.isNotBlank() &&
            contactLastName.isNotBlank() &&
            contactEmail.matches(SharedUtils.emailPattern) &&
            contactPhoneNumber.matches(SharedUtils.phonePattern) &&
            contactAddress.isNotBlank()

fun Contractor.businessInfoComplete(): Boolean =
    stateEntityNumber.isNotBlank() &&
            ein.isNotBlank() &&
            !trade.isNullOrBlank()

fun Contractor.infoComplete(): Boolean =
    basicInfoComplete() && businessInfoComplete()

// this is the updated validation for the new registration flows
fun Contractor.newInfoComplete(): Boolean =
    primaryUserComplete() &&
            businessOperationsComplete() &&
            businessProfileComplete() &&
            businessVerificationComplete() &&
            ownersComplete()

fun Contractor.primaryUserComplete(): Boolean =
    contactFirstName.isNotBlank() &&
            contactLastName.isNotBlank() &&
            contactEmail.matches(SharedUtils.emailPattern) &&
            contactPhoneNumber.matches(SharedUtils.phonePattern)

fun Contractor.businessOperationsComplete(): Boolean =
    name.isNotBlank() &&
            legalName.isNotBlank() &&
            email.matches(SharedUtils.emailPattern) &&
            phoneNumber.matches(SharedUtils.phonePattern) &&
            contactAddress.isNotBlank() &&
            operationStates.isNotEmpty()

fun Contractor.businessProfileComplete(): Boolean =
    !trade.isNullOrBlank() &&
            annualRevenue != null

fun Contractor.businessVerificationComplete(): Boolean =
    !entityType.isNullOrBlank() &&
            address.isNotBlank() &&
            ein.isNotBlank()

fun Contractor.ownersComplete(): Boolean =
    owners.isNotEmpty() && owners.all { it.isValid() } && owners.sumOf { it.ownership } == 100 && owners.any { it.document != null }